import { RadioButtonWithLabelOption, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FormikRadioButtonGroup } from '~commonInfra/components/FormikRadioButtonGroup';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { HelpService } from '~commonInfra/services/HelpService';
import { Messages } from '~src/codegen/Localize';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';
import { componentRegistryEntry } from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '~src/settings/general-settings/components/site-settings/ReactSiteSettingsForSiteAdmin';
import { learnMoreStyle, settingsRadioButtonItemHeight } from '~src/settings/styles/CommonStyles';

export const EXTERNAL_ACTIONS_WORKFLOWS_SECTION_TEST_ID = 'external-actions-workflows-site-setting';
export const EXTERNAL_ACTIONS_WORKFLOWS_LEARN_MORE_TEST_ID = 'external-actions-workflows-learn-more';
export const EXTERNAL_ACTIONS_WORKFLOWS_ENABLE_BUTTON_TEST_ID = 'external-actions-workflows-enable';
export const EXTERNAL_ACTIONS_WORKFLOWS_DISABLE_BUTTON_TEST_ID = 'external-actions-workflows-disable';

export type ExternalActionsWorkflowsSectionProps = SiteSettingsForSiteAdminProps<'workflowExtensionEnabled'>;

/**
 * Settings section for management Workflow feature
 */
export function ExternalActionsWorkflowsSection() {

  const buttonList = React.useMemo(() => getButtonListAndClassName(), []);

  if (!FeatureFlags.workflowSiteControl) {
    return null;
  }

  return (
    <SettingsSection
      title={Messages.externalActionsWorkflowsSiteSettingTitle()}
      testId={EXTERNAL_ACTIONS_WORKFLOWS_SECTION_TEST_ID}
      description={
        <TextLinkWidget
          className={learnMoreStyle}
          href={HelpService.getServerHelpUrlByCategory('workflow')}
          target='_blank'
          testId={EXTERNAL_ACTIONS_WORKFLOWS_LEARN_MORE_TEST_ID}
        >
          {Messages.learnMore()}
        </TextLinkWidget>
      }
    >
      <FormikRadioButtonGroup
        aria-label={Messages.externalActionsWorkflowsSiteSettingTitle()}
        buttonList={buttonList}
        className={settingsRadioButtonItemHeight}
        name={'settings.workflowExtensionEnabled'}
      />
    </SettingsSection>
  );
}


function getButtonListAndClassName(): RadioButtonWithLabelOption<boolean>[] {

  const externalActionsWorkflowsEnableButtonLabel = <>
    <div>{Messages.externalActionsWorkflowsEnable()}</div>
    <div>{Messages.externalActionsWorkflowsEnableDescription()}</div>
  </>;
  const externalActionsWorkflowsDisableButtonLabel = <>
  <div>{Messages.externalActionsWorkflowsDisable()}</div>
  <div>{Messages.externalActionsWorkflowsDisableDescription()}
  </div>
</>;

  return[
    {
      value: true,
      label: externalActionsWorkflowsEnableButtonLabel,
      testId: EXTERNAL_ACTIONS_WORKFLOWS_ENABLE_BUTTON_TEST_ID
    },
    {
      value: false,
      label: externalActionsWorkflowsDisableButtonLabel,
      testId: EXTERNAL_ACTIONS_WORKFLOWS_DISABLE_BUTTON_TEST_ID
    }
  ];
}

/* for registering the component in settings registry */
export const ExternalActionsWorkflowsSectionSpecs = componentRegistryEntry({
    name: 'ExternalActionsWorkflowsSection',
    component: ExternalActionsWorkflowsSection,
  });